import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53f0e98c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "sceneContainerRef",
  id: "scene-container"
}
const _hoisted_2 = {
  ref: "canvasRef",
  id: "canvas",
  width: "500",
  height: "500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", _hoisted_2, null, 512)
  ], 512))
}